import { useBetterStackStatus } from '../../../../hooks/use-betterstack-status'

// Helper function to get URL query parameters
const getUrlParam = (param: string): string | null => {
	if (typeof window === 'undefined') return null
	const urlParams = new URLSearchParams(window.location.search)
	return urlParams.get(param)
}

// Status configuration mapping
const STATUS_CONFIG = {
	operational: {
		color: '#10b981',
		text: 'Online',
	},
	degraded_performance: {
		color: '#f59e0b',
		text: 'Degraded',
	},
	partial_outage: {
		color: '#f97316',
		text: 'Issues',
	},
	major_outage: {
		color: '#ef4444',
		text: 'Offline',
	},
} as const

// Helper function to get status config
const getStatusConfig = (statusKey: string | null) => {
	if (!statusKey || !(statusKey in STATUS_CONFIG)) {
		return {
			color: 'var(--NavItem-icon-color)',
			text: 'Status',
		}
	}
	return STATUS_CONFIG[statusKey as keyof typeof STATUS_CONFIG]
}

export function useStatusColor() {
	const { status, loading, error } = useBetterStackStatus()

	// Check for test status override first
	const testStatus = getUrlParam('status')
	if (testStatus) {
		return getStatusConfig(testStatus).color
	}

	// Fall back to actual status
	if (loading || error || !status) {
		return getStatusConfig(null).color
	}

	return getStatusConfig(status.status).color
}

export function useStatusText() {
	const { status, loading, error } = useBetterStackStatus()

	// Check for test status override first
	const testStatus = getUrlParam('status')
	if (testStatus) {
		return getStatusConfig(testStatus).text
	}

	// Fall back to actual status
	if (loading) {
		return getStatusConfig(null).text
	}

	if (error || !status) {
		return getStatusConfig(null).text
	}

	return getStatusConfig(status.status).text
}
